import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  divider: {
    height: "100%",
    borderLeft: "1px solid",
    position: "absolute",
    zIndex: 1
  },
  horseNumberDivider: {
    left: 84
  },
  surfaceDivider: {
    left: 728
  }
});
